import http from '@/utils/request'
import requestJxs from '@/utils/requestJxs'
import requestManage from '@/utils/requestManage'
import {getUserInfo} from '@/utils/common'
import {selectApi} from '@/config/config'

// 导出
export const exportReport = (data) => {
    const userInfo = getUserInfo()
    return http('/backstage/exportExcel.do', {
        params: {
            dlid: userInfo.sysid,
            ...data
        }
    })
}

// 获取按钮权限
export const getOperatePerms = (hmid) => {
    const userInfo = getUserInfo()
    return http(selectApi, {
        params: {
            sqlfilename: "new-sql-xtgl.xml",
            sqlkey: "hman-list",
            userid: userInfo.sysid,
            hmid
        }
    })
}

// 获取公司选项
export const getCompanyList = () => {
    return http(selectApi, {
        params: {
            sqlfilename: "new-sql-jxsgl.xml",
            sqlkey: "gsxx-list",
        }
    })
}

// 获取经销商选项
export const getJxsList = (jxsbm) => {
    return http(selectApi, {
        params: {
            sqlfilename: "new-sql-web.xml",
            sqlkey: "spf-list-jhd",
            jxsbm,
        }
    })
}
// 获取经销商选项
export const getJxsListNew = (data) => {
    return http(selectApi, {
        params: {
            sqlfilename: "new-sql-web.xml",
            sqlkey: "spf-list-jhd-new",
            ...data,
        }
    })
}
// 获取经销商选项
export const getZmdListNew = (data) => {
    return http(selectApi, {
        params: {
            sqlfilename: "new-sql-web.xml",
            sqlkey: "zmdmc-list-jhd-new",
            ...data,
        }
    })
}

// 根据老的经销商编码获取经销商选项
export const getJxsListByOld = () => {
    const userInfo = getUserInfo()
    return http('/frontend/xtgl_user_jxs/jxsList.do', {
        params: {
            ccusheadcode: userInfo.jxsxx.oldjxsbm
        }
    })
}

// 获取产品分类
export const inventoryClass = () => {
    return http('/frontend/home/inventoryClass.do')
}

// 获取日志
export const getLog = (data) => {
    return requestJxs('/jxs/log/list', {
        method: 'post',
        data: data
    })
}

// 上报登录日志
export const dcyxSysLogAdd = (zh, user='', opeType='自动登录', res='登录成功', czmk='经销商PC端') => {
    return requestManage('/manage/dcyxSysLog/add', {
        method: 'post',
        data: {
            param: {
                crcs: JSON.stringify({zh: zh}),
                czjg: JSON.stringify({res}),
                czmk,
                gnanmc: opeType,
                cznr: JSON.stringify({'操作': opeType}),
                czryname: user,
                hmid: '',
                djh: zh,
                userAgent: navigator.userAgent,
            }
        }
    })
}
